module.exports = __webpack_public_path__ + "img/tips-night.44113166.svg";